import { FormikProps } from 'formik';

import { Select } from '../../../../../ui';
import { ProfileFormValues } from '../EditModal';

const pronounOptions = ['', 'He/Him', 'She/Her', 'They/Them'] as const;
export type Pronouns = (typeof pronounOptions)[number];

export function PronounsField({ values, setFieldValue }: FormikProps<ProfileFormValues>) {
    const options = pronounOptions.reduce((accum, pronoun) => {
        if (pronoun !== '') {
            accum.push({ label: pronoun, value: pronoun });
        }
        return accum;
    }, [] as { label: Exclude<Pronouns, ''>; value: Exclude<Pronouns, ''> }[]);

    const value = !values.pronouns
        ? null
        : {
              label: values.pronouns,
              value: values.pronouns,
          };

    return (
        <Select
            label="Pronouns"
            name="pronouns"
            id="pronouns"
            value={value}
            placeholder="Select your pronouns"
            isClearable={true}
            options={options}
            onChange={(option) => {
                setFieldValue('pronouns', option?.value || null);
            }}
        />
    );
}
